@if (loading(); as loader) {
	@if (loading().show) {
		<tec-spinner [show]="loader.show" [text]="loader.text"
			[opaque]="loader.opaque" [watermark]="loader.watermark" [img]="spinnerImg()"></tec-spinner>
	}
}

@if (loadingMaster(); as loader) {
	@if (loader.show) {
		<tec-spinner [show]="loader.show" [text]="loader.text"
			[opaque]="loader.opaque" [watermark]="loader.watermark" [img]="spinnerImg()"></tec-spinner>
	}
}

@if (snackbar(); as snackBar) {
	<tec-snackbar [show]="snackBar?.show" [label]="snackBar?.text" (close)="snackbarService.hide()"></tec-snackbar>
}

@if (modalConfirmation(); as confirmation) {
	<tec-modal [isVisible]="confirmation?.show" type="confirmation"
		[buttonSecondaryLabel]="confirmation?.buttonSecondaryLabel"
		[buttonPrimaryLabel]="confirmation?.buttonPrimaryLabel"
		[buttonPrimaryStyle]="confirmation?.buttonPrimaryStyle"
		(closeEvent)="dialogConfirmationService.setCloseDialogConfirmation($event)">
		<ng-container body>
			<tec-tag-icon [size]="'default'" [icon]="confirmation.icon"
				[status]="confirmation.iconStatus"></tec-tag-icon>
			<div class="body__text">
				<h4>{{ confirmation?.title }}</h4>
				<span>{{ confirmation?.description }}</span>
			</div>
		</ng-container>
	</tec-modal>
}

<router-outlet></router-outlet>
